import { acceptHMRUpdate, defineStore } from 'pinia';
import type { AiModel } from '@/types/AiModel.ts';

interface State {
    // UI
    isFullLoading: boolean;
    isInsideWebView: boolean;
    isRunBlocked: boolean;
    // Privacy
    isContentProtectionEnabled: boolean;
    isTaskbarIconVisible: boolean;
    // Dynamic indexes
    dynamicVariableIndex: number;
    dynamicProfileIndex: number;
    // Stream mapping
    streamSessionIdMap: Record<string, string>;
    streamPromptConfigIdMap: Record<string, string>;
    streamVariableChainHashMap: Record<string, string>;
    // Other
    desktopAppVersion: string;
    aiModels: Record<AiModel['id'], AiModel>;
    aiModelCatalogStatus: 'idle' | 'loading' | 'ready' | 'failed';
    defaultModelId: string;
    modelReplacements: Record<string, string>;
}

export const useSessionStore = defineStore('v3/session', {
    state: (): State => {
        return {
            // UI
            isFullLoading: false,
            isInsideWebView: false,
            isRunBlocked: false,
            // Privacy
            isContentProtectionEnabled: true,
            isTaskbarIconVisible: false,
            // Dynamic indexes
            dynamicVariableIndex: 0,
            dynamicProfileIndex: 0,
            // Stream mapping
            streamSessionIdMap: {},
            streamPromptConfigIdMap: {},
            streamVariableChainHashMap: {},
            // Other
            desktopAppVersion: '',
            aiModels: {},
            aiModelCatalogStatus: 'idle',
            defaultModelId: '',
            modelReplacements: {},
        };
    },
    persist: {
        storage: sessionStorage,
    },
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSessionStore, import.meta.hot));
}
